import axios from 'axios';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import imageOrder from "../../Assets/images/order section.jpg";
import Pagination from '../Pagination/Pagination.jsx';
import TimeAgo from '../TimeAgo/TimeAgo.jsx';
import "./allOrderLoggedUser.css";
import { UserContext } from '../../Context/UserContext.js';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';
import { CartContext } from '../../Context/CartContext.js';
import { OrderContext } from '../../Context/OrderContext.js';



export default function AllOrderLoggedUser() {
   const [orders, setOrders] = useState([]);
   const [pageCount, setPageCount] = useState(0);
   const { userToken } = useContext(UserContext);
   const { clearCart, setOrderCount } = useContext(CartContext);

   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   const fetchData = async (currentPage) => {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/getLoggedUserOrder?limit=10&page=${currentPage}`, { headers: header })
         .then(({ data }) => {
            setOrders(data.orders);
            setPageCount(data.metadata.numberOfPages);
            setOrderCount(data.orderCount);
         })
         .catch((error) => {
            Swal.fire({
               title: error.response?.data.message,
               text: "Please Try Again",
               icon: "error"
            });
         })
   }

   const handlePageClick = (data) => {
      fetchData(data?.selected + 1)
   }

   useEffect(() => {
      if (userToken) {
         fetchData(1)
      }
   }, [userToken])
   return (
      <Fragment>
         <CustomTitle title="جميع الطلبات" />

         <div className="container AllOrderLoggedUser">
            <h1 className='main-header'>تفاصيل جميع الطلبات</h1>
            <div className='under-header'></div>

            <div className="row">
               <div className="col-md-4">
                  <div className=''>
                     <img src={imageOrder} className='w-100' alt="order" />
                  </div>
               </div>

               <div className="col-md-8">

                  {orders.length ?

                     orders.map((ele) =>
                        <div key={ele._id} className='position-relative overflow-hidden orderItem border-bottom '>
                           <div className=' d-flex justify-content-between align-items-center p-2 mt-2' >

                              <div>
                                 <p className='my-1'>Order Number : {ele.order_Number}</p>
                                 <p className='my-1'>Patient Name : {ele.patient_Name}</p>
                                 <p className='my-1'>Total Price : {Math.round(ele.total_Price)} EGP</p>
                                 <p className='my-1'>Total Price After Discount: {ele.profilePrice ? ele.profilePrice : Math.round(ele.total_Price_After_Discount)} EGP</p>
                                 <p className='my-1'>Created At: {ele.createdAt.slice(0, 10)}</p>
                                 <p > <TimeAgo createdAt={ele.createdAtOrder} />  </p>

                                 {
                                    ele.is_Cancel ?
                                       <div>
                                          <p className='alert alert-warning p-1 '>Canceled At: {ele.cancel_At ? ele.cancel_At?.slice(0, 10) : "Unknown cancellation time"}</p>
                                       </div>
                                       : (!ele.is_Cancel && ele.is_Paid) ?
                                          <div>
                                             <a href={ele.invoice_pdf} className='btn btn-new-color btn-sm' download target="_black">تنزيل الفاتورة</a>
                                          </div>
                                          : ""
                                 }


                                 <div className='mt-4'>
                                    <p className='p-0 m-0'>Message : </p>
                                    <p className='mt-0 mb-4'><span className='alert alert-secondary p-1'> {ele.message ? ele.message : "Not Found The Message Until Now !"} </span></p>
                                 </div>
                              </div>

                           </div>

                           <div>

                              {
                                 ele.is_Cancel ?
                                    <div className='alert alert-warning fw-bold text-center p-1 d-flex justify-content-between align-item-center'><span>❌</span> <span>تم ألغاء الطلب  للمزيد من المعلومات يرجى الاتصال على 63120</span></div>
                                    : ele.is_Approved && ele.is_Paid ?
                                       <div className=''>
                                          <details className='text-start mb-1'>
                                             <summary className='btn bg-main btn-sm'>Approved Details <i class="fa-solid fa-circle-info mx-2"></i></summary>
                                             <p className='ms-3 m-1'>Approval branch :  <span className='fw-bold'>{ele.branch?.name}</span></p>
                                             <p className='ms-3 m-1'>Approval Company : <span className='fw-bold'>{ele.company?.name}</span> </p>
                                             <p className='ms-3 m-1'>Approval At :      <span className='fw-bold'>{ele.approved_At?.slice(0, 10)}</span> </p>
                                          </details>
                                          <div className='alert alert-success fw-bold text-center p-1 d-flex justify-content-between align-item-center'><span>✅</span> <span>تمت الموافقة علي الطلب برجاء تحميل الفاتورة و التوجه لمقدم الخدمة</span></div>
                                       </div>
                                       : ele.is_Paid ?
                                          <div className='alert alert-success fw-bold text-center p-1 d-flex justify-content-between align-item-center'><span>🕗</span> <span>تم تسجيل الطلب يرجى  طباعة الفاتورة والتوجه لاقرب فرع لسحب العينات</span></div>
                                          : !ele.is_Paid && !ele.is_Approved && !ele.is_Cancel ?
                                             <div className='alert alert-success fw-bold text-center p-1 d-flex justify-content-between align-item-center'><span>🕗</span> <span>تم تسجيل الطلب  يرجى   انتظار موافقة الادمن </span></div>
                                             :
                                             <div className='alert alert-danger fw-bold text-center p-1 d-flex justify-content-between align-item-center'><span>⛔</span> <span>حدث خطأ ما أثناء التسجيل يرجى الاتصال على الخط الساخن  01066991090</span></div>
                              }
                           </div>

                        </div>
                     )
                     : <div className="alert alert-danger mt-2">لا يوجد اى طلبات سابقة</div>

                  }

               </div>
            </div>

            <div className='text-center'>
               <Link className='btn text-white bgBlack w-75 my-4' to="/price" onClick={() => { clearCart() }}> عمل طلب جديد  </Link>
            </div>

            <Pagination handlePageClick={handlePageClick} pageCount={pageCount} />
         </div>

      </Fragment>
   )
}
